import { constructCdnUrl } from '@office-start/url-parser-utility';
export function getThemedImageFromCallout(callout, componentContext) {
    var image = callout === null || callout === void 0 ? void 0 : callout.image;
    if (!image) {
        return undefined;
    }
    switch (image.type) {
        case 'url':
            return image.imageUrls;
        case 'cdn':
            var cdnDomain = componentContext === null || componentContext === void 0 ? void 0 : componentContext.cdnDomain;
            var light = constructCdnUrl(cdnDomain, 'officestartresources', image.imageInfo.light.fileName, image.imageInfo.light.fileExtension);
            var dark = constructCdnUrl(cdnDomain, 'officestartresources', image.imageInfo.dark.fileName, image.imageInfo.dark.fileExtension);
            return !!light && !!dark
                ? {
                    light: light,
                    dark: dark,
                }
                : undefined;
        default:
            return undefined;
    }
}
//# sourceMappingURL=getThemedImageFromCallout.js.map